import React, { forwardRef, useEffect, useState, useImperativeHandle } from 'react'
import { Row, Col, DatePicker, Button, Slider } from 'antd'
import PushTimePicker from './PushTimePicker';
import { PlusCircleFilled, CloseCircleFilled } from '@ant-design/icons'
import moment from 'moment'
import './BrightnessSchedulerEditor.css'
import { connect } from 'react-redux';
import { requestServerPost, requestServerGet, selectPage } from '../actions';
import Cleave from 'cleave.js/react';
const { RangePicker } = DatePicker;

const IconSlider = (props) => {
    const formatter = (value) => `${value}%`;
    const { max, min, onChange, value } = props;
    const mid = Number(((max - min) / 2).toFixed(5));
    const preColorCls = value >= mid ? '' : 'icon-wrapper-active';
    const nextColorCls = value >= mid ? 'icon-wrapper-active' : '';
    return (
        <div className="icon-wrapper">
            <img src="/cms/assets/svgs/icons/brightness_0_icon.svg" className={preColorCls} style={{ width: "30px", height: "30px", margin: "0 20px" }} />
            <Slider tooltip={{ formatter }} {...props} onChange={onChange} value={value} style={{ width: "50% !important" }} />
            <img src="/cms/assets/svgs/icons/brightness_100_icon.svg" className={nextColorCls} style={{ width: "30px", height: "30px", margin: "0 20px" }} />
        </div>
    );
};

const BrightnessSchedulerEditor = forwardRef((props, ref) => {


    const weekdays = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"]
    const weekdayNums = [1, 2, 3, 4, 5, 6, 0]
    const { data } = props;
    const { WeekDay, StartTime, EndTime, StartDate, EndDate } = data;
    // const [schedules, setSchedules] = useState({ WeekDay: [], StartTime: "", EndTime: "", StartDate: "", EndDate: "" })
    const [scData, setScData] = useState(null)
    const [days, setDays] = useState([])
    const [startTime, setStartTime] = useState("")
    const [endTime, setEndTime] = useState("")
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")
    const [brightness, setBrightness] = useState(100)
    const [priority, setPriority] = useState(1)


    // const dateFormat = 'YYYY/MM/DD';
    const dateFormat = 'DD/MM/YYYY';
    const inputdateFormat = 'YYYY-MM-DD';
    const inputformat = 'HH:mm:ss';
    const format = 'HH:mm';
    const timeInputStyle = {
        backgroundColor: "#4C4D52",
        borderRadius: "4px",
        overflow: "hidden",
        color: "white !important",
        fontColor: "white !important",
        fontWeight: 600,
        height: "50px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }

    useEffect(() => {

        const { onSave = () => { }, data, requestServerPost, usertoken } = props;
        //setScData(data)
        reloadFromProps();
        // setSchedules({ weekDays, StartTime: StartTime, EndTime: EndTime, StartDate: StartDate, EndDate: EndDate })
        return () => {
            console.log('cleaned up');
        };
    }, [])

    const reloadFromProps = () => {
        const { data } = props;
        setScData(data)

        if (!data)
            return
        const { WeekDay, StartTime, EndTime, StartDate, EndDate, Brightness, Priority = 1 } = data;
        const weekDays = WeekDay.split(',')

        setDays(weekDays)
        setStartTime(StartTime)
        setEndTime(EndTime)
        setStartDate(StartDate)
        setEndDate(EndDate)
        setBrightness(Brightness);
        setPriority(Priority);
    }

    useImperativeHandle(ref, () => ({

        resetUnsavedChanged() {
            reloadFromProps();
        }

    }));


    const save = () => {
        const { onSave = () => { }, data, requestServerPost, usertoken } = props;

        const params = new FormData();
        const { BrightnessScheduleID, ScreenID } = scData;

        params.append("brightnessscheduleid", BrightnessScheduleID)
        params.append("screenid", ScreenID)
        params.append("weekday", days.join(","))
        params.append("starttime", startTime)
        params.append("endtime", endTime)
        params.append("startdate", startDate)
        params.append("enddate", endDate)
        params.append("brightness", brightness)
        params.append("priority", priority)


        requestServerPost("update_brightnessschedule", params, {}, (response) => {
            onSave({ WeekDay: days.join(","), StartTime: startTime, EndTime: endTime, StartDate: startDate, EndDate: endDate, Brightness: brightness, Priority: priority })
        }, usertoken);
    }
    const addStartEndTime = () => {
        setStartTime("00:00:00");
        setEndTime("23:59:59");
    }
    const addStartEndDate = () => {
        setStartDate(moment().format(inputdateFormat));
        setEndDate(moment().format(inputdateFormat));
        // console.log(moment().format("YYYY-MM-DD"))
        // this.setState({ StartDate: "00:00:00", EndDate: "23:59:59" })
    }
    const onStartEndDateChanged = (moments, value) => {
        setStartDate(moments[0].format(inputdateFormat));
        setEndDate(moments[1].format(inputdateFormat));
    }
    const onStartTimeChanged = (moment, value) => {
        // console.log("onStartTimeChanged ")
        if (!moment)
            return;
        // console.log("onStartTimeChanged " + moment.format(inputformat))
        moment.second(0);
        setStartTime(moment.format(inputformat));
    }
    const onEndTimeChanged = (moment, value) => {
        // console.log("onEndTimeChanged")
        if (!moment)
            return;
        moment.second(0);
        setEndTime(moment.format(inputformat));
    }
    return (
        <Row gutter={16} style={{ width: "480px" }} justify="space-between">
            <Col span={24} style={{ height: "50px" }}>
                <IconSlider min={0} max={100} onChange={setBrightness} value={brightness}></IconSlider>
            </Col>
            <Col span={24} style={{ height: "50px" }}>
                <div style={{ display: "flex", width: "100%", borderRadius: "4px", overflow: "hidden" }}>
                    {weekdays.map((day, index) => {
                        const activeStyle = { backgroundColor: "#5F92F8", color: "#ffffff" }
                        const inactiveStyle = { backgroundColor: "#EEEEEE", color: "#DEDEDE" }
                        const isActive = days.indexOf(`${weekdayNums[index]}`) !== -1
                        const selectedStyle = isActive ? activeStyle : inactiveStyle;
                        return <div onClick={() => {
                            if (isActive) {
                                const newDays = days.filter((d) => {
                                    return d !== `${weekdayNums[index]}`
                                })
                                setDays(newDays)
                            }
                            else {
                                setDays([...days, `${weekdayNums[index]}`])
                            }
                        }} className="center-content" style={{ flex: 1, height: "40px", fontSize: "13px", cursor: "pointer", ...selectedStyle }}>{day}</div>
                    })}
                </div>
            </Col>
            <Col className="center-content schedule-picker" span={11} style={{ height: "50px" }}>
                {(startTime == "" && endTime == "") ? <Button type="text" onClick={addStartEndTime} icon={<PlusCircleFilled></PlusCircleFilled>}>Add Specific Time</Button> : (
                    <Row justify="start">
                        <Col className="center-content weekdayscheduler-timeinput" span={10}>
                            {/* <Cleave placeholder="HH:MM" style={{
                                backgroundColor: "transparent",
                                outlineWidth: 0,
                                outline: "none",
                                border: "none",
                                textAlign: "center"
                            }}
                                options={{ time: true, timePattern: ['h', 'm'] }}
                            // onFocus={onStartTimeChanged}
                            // onChange={onStartTimeChanged} 
                            /> */}
                            <PushTimePicker
                                allowClear={false}
                                bordered={false}
                                suffixIcon={null}
                                // onChange={onStartTimeChanged}
                                onSelect={onStartTimeChanged}
                                value={moment(startTime, inputformat)}
                                defaultValue={moment(startTime, inputformat)}
                                format={format} ></PushTimePicker>
                        </Col>
                        <Col className="center-content" span={2}>
                            -
                        </Col>
                        <Col className="center-content weekdayscheduler-timeinput" span={10}>
                            <PushTimePicker
                                allowClear={false}
                                bordered={false}
                                suffixIcon={null}
                                // onChange={onEndTimeChanged}
                                value={moment(endTime, inputformat)}
                                onSelect={onEndTimeChanged}
                                defaultValue={moment(endTime, inputformat)}
                                format={format} ></PushTimePicker>
                            {/* <Cleave placeholder="HH:MM" style={{
                                backgroundColor: "transparent",
                                outlineWidth: 0,
                                outline: "none",
                                border: "none",
                                textAlign: "center"
                            }}
                                options={{ time: true, timePattern: ['h', 'm'] }}
                            // onFocus={onStartTimeChanged}
                            // onChange={onStartTimeChanged} 
                            /> */}
                        </Col>
                        <Col>
                            <div onClick={(e) => {
                                setStartTime("");
                                setEndTime("");
                                e.preventDefault();
                            }} className="btn-remove-item" style={{ position: "absolute", right: "-26px", top: "8px" }}>
                                <CloseCircleFilled style={{ color: "rgb(221, 221, 221)", cursor: "pointer", fontSize: "20px" }} />
                            </div>
                        </Col>
                    </Row>

                )}
            </Col>
            <Col className="center-content schedule-picker" span={11} style={{ height: "50px" }}>
                {(startDate == "" && endDate == "") ? <Button onClick={addStartEndDate} type="text" icon={<PlusCircleFilled></PlusCircleFilled>}>Add Specific Date</Button> : (
                    <Row justify="center" style={{ marginRight: "26px" }}>
                        <Col className="center-content weekdayscheduler-dateinput">
                            <RangePicker
                                size="small"
                                allowClear={false}
                                bordered={false}
                                suffixIcon={null}
                                onChange={onStartEndDateChanged}
                                separator="-"
                                defaultValue={[moment(startDate, inputdateFormat), moment(endDate, inputdateFormat)]}
                                format={dateFormat} />
                        </Col>
                        <Col>
                            <div onClick={(e) => {
                                setStartDate("");
                                setEndDate("");
                                e.preventDefault();
                            }} className="btn-remove-item" style={{ position: "absolute", right: "-26px", top: "8px" }}>
                                <CloseCircleFilled style={{ color: "rgb(221, 221, 221)", cursor: "pointer", fontSize: "20px" }} />
                            </div>
                        </Col>
                    </Row>
                )}
            </Col>
            <Col span={24}>
                <Row justify="end">
                    <Col>
                        <Button onClick={save} type="primary">SAVE</Button>
                    </Col>

                </Row>
            </Col>
        </Row >
    )
});

const mapStateToProps = (state) => {
    return { userdata: state.userdata, usertoken: state.usertoken, selectedBrandData: state.selectedBrandData };
}

export default connect(mapStateToProps, { requestServerGet, requestServerPost, selectPage })(BrightnessSchedulerEditor);
